/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');

    if (!this.container) return;

    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    // Store the element that opened the search drawer
    this.searchOpenTrigger = null;

    // Close button inside search drawer
    this.closeButton = this.container.querySelector(
      '.side-panel-close, .side-panel-close-button, button[aria-label="Close"], button.close, .close'
    );

    // Make search drawer focusable and meaningful for screen readers
    this.container.setAttribute('role', 'dialog');
    this.container.setAttribute('aria-modal', 'true');
    this.container.setAttribute('aria-label', 'Search');
    this.container.setAttribute('tabindex', '-1');

    this.setupEventListeners();
  }

  setupEventListeners() {
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    }

    if (this.input) {
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    this.button.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();

        // Save opener before opening drawer
        this.searchOpenTrigger = event.currentTarget;

        this.open();

        return false;
      });
    });

    // Close button click
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.close();
      });
    }

    // Escape key close
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.container.classList.contains('active')) {
        event.preventDefault();
        this.close();
      }
    });
  }

  open() {
    document.body.classList.add('open-cc');
    this.container.classList.add('active');

    setTimeout(() => {
      // First redirect focus to the drawer
      this.container.focus({
        preventScroll: true
      });

      // Then move focus to search input for better usability
      if (this.input) {
        this.input.focus({
          preventScroll: true
        });
      }
    }, 100);

    dispatchCustomEvent('search:open');
  }

  getQuery() {
    return this.input ? this.input.value.trim() : '';
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }

    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');

        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this;
    let submitButton = this.container.querySelector('#search-results-submit');

    if (submitButton) {
      submitButton.addEventListener('click', () => {
        _this.form.submit();
      });
    }
  }

  close() {
    this.container.classList.remove('active');
    document.body.classList.remove('open-cc');

    dispatchCustomEvent('search:close');

    // Return focus back to the opener
    setTimeout(() => {
      if (this.searchOpenTrigger) {
        this.searchOpenTrigger.focus({
          preventScroll: true
        });
      }
    }, 100);
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});